import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
function Activity() {
    return (
        <>
      
  <svg height={25}   fill="#aeae10" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Folder</title>
  
  <FontAwesomeIcon icon="fa-solid fa-folder"  />
  <path
        fill="#ffffff" // White color for the plus icon
         transform="translate(0,1)"
        d="M13 11V9C13 8.45 12.55 8 12 8C11.45 8 11 8.45 11 9V11H9C8.45 11 8 11.45 8 12C8 12.55 8.45 13 9 13H11V15C11 15.55 11.45 16 12 16C12.55 16 13 15.55 13 15V13H15C15.55 13 16 12.55 16 12C16 11.45 15.55 11 15 11H13Z"
      />
  </svg>

  
      
      </>
    )
  }
  
  export default Activity
  